export default __webpack_public_path__ + "static/dtm_lite-1e87563d7802fb0e9ca7f1e4b5e5fe56.png";